export default __webpack_public_path__ + "static/media/placeholder.21868459.svg";